module.exports = __webpack_public_path__ + "img/transfer20.13c12347.jpeg";